// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__1r2FF","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__2aBBl"};